/* Jadel Custom JS — juli 2026 */

document.addEventListener('DOMContentLoaded', function() {

  /* === SEO tekst inklapbaar === */
  var collectionDesc = document.querySelector('.collection .rte, .collection-description, [class*="collection"] .rte');
  if (collectionDesc && collectionDesc.scrollHeight > 150) {
    collectionDesc.classList.add('collection-seo-text');
    var btn = document.createElement('button');
    btn.className = 'seo-toggle-btn';
    btn.textContent = 'Lees meer';
    btn.addEventListener('click', function() {
      collectionDesc.classList.toggle('expanded');
      btn.textContent = collectionDesc.classList.contains('expanded') ? 'Lees minder' : 'Lees meer';
    });
    collectionDesc.parentNode.insertBefore(btn, collectionDesc.nextSibling);
  }

  /* === Winkelwagen animatie === */
  document.querySelectorAll('.product-form__submit').forEach(function(b) {
    b.addEventListener('click', function() {
      setTimeout(function() {
        b.classList.add('added');
        b.addEventListener('animationend', function() {
          b.classList.remove('added');
        }, { once: true });
      }, 300);
    });
  });

  /* === Verberg Judge.me 'Geen beoordelingen' === */
  document.querySelectorAll('.jdgm-preview-badge').forEach(function(badge) {
    if (!badge.querySelector('.jdgm-prev-badge__stars') ||
        badge.getAttribute('data-average-rating') === '0.00' ||
        badge.textContent.trim().includes('Geen beoordelingen')) {
      badge.style.display = 'none';
    }
  });

  /* === Zoekfilter + Tag-filters ALLEEN op collectiepagina’s === */
  var productGrid = document.querySelector('#product-grid, .product-grid, [id^="product-grid"]');
  var isCollectionPage = window.location.pathname.indexOf('/collections/') !== -1;
  if (!productGrid || !isCollectionPage) return;

  var pathParts = window.location.pathname.split('/');
  var collIdx = pathParts.indexOf('collections');
  var collectionHandle = (collIdx !== -1 && pathParts[collIdx + 1]) ? pathParts[collIdx + 1] : null;
  if (!collectionHandle) return;

  var originalGridHTML = productGrid.innerHTML;

  /* Helper: normalize product.tags (kan string of array zijn) */
  function getTagsArray(product) {
    if (!product.tags) return [];
    if (Array.isArray(product.tags)) {
      return product.tags.map(function(t) { return t.toLowerCase().trim(); });
    }
    return product.tags.toLowerCase().split(',').map(function(t) { return t.trim(); });
  }

  /* --- AJAX: Fetch ALL products in collection --- */
  var jadelAllProducts = null;
  var jadelFetchPromise = null;

  function fetchAllProducts() {
    if (jadelFetchPromise) return jadelFetchPromise;
    jadelFetchPromise = new Promise(function(resolve) {
      var allProducts = [];
      var page = 1;
      function fetchPage() {
        fetch('/collections/' + collectionHandle + '/products.json?limit=250&page=' + page)
          .then(function(r) { return r.json(); })
          .then(function(data) {
            if (data.products && data.products.length > 0) {
              allProducts = allProducts.concat(data.products);
              if (data.products.length === 250) {
                page++;
                fetchPage();
              } else {
                jadelAllProducts = allProducts;
                resolve(allProducts);
              }
            } else {
              jadelAllProducts = allProducts;
              resolve(allProducts);
            }
          })
          .catch(function() {
            jadelAllProducts = allProducts;
            resolve(allProducts);
          });
      }
      fetchPage();
    });
    return jadelFetchPromise;
  }

  /* --- ZOEKBALK (inklapbaar icoon) --- */
  var searchContainer = document.createElement('div');
  searchContainer.className = 'jadel-collection-search';

  var toggleBtn = document.createElement('button');
  toggleBtn.type = 'button';
  toggleBtn.className = 'jadel-collection-search__toggle';
  toggleBtn.setAttribute('aria-label', 'Zoeken in collectie');
  toggleBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>';

  var searchWrapper = document.createElement('div');
  searchWrapper.className = 'jadel-collection-search__wrapper';
  var input = document.createElement('input');
  input.type = 'text';
  input.className = 'jadel-collection-search__input';
  input.placeholder = 'Zoek in deze collectie...';
  input.setAttribute('autocomplete', 'off');
  var clearBtn = document.createElement('button');
  clearBtn.type = 'button';
  clearBtn.className = 'jadel-collection-search__clear';
  clearBtn.innerHTML = '&times;';
  searchWrapper.appendChild(input);
  searchWrapper.appendChild(clearBtn);

  var countLabel = document.createElement('span');
  countLabel.className = 'jadel-collection-search__count';

  searchContainer.appendChild(toggleBtn);
  searchContainer.appendChild(searchWrapper);
  searchContainer.appendChild(countLabel);
  productGrid.parentNode.insertBefore(searchContainer, productGrid);

  toggleBtn.addEventListener('click', function() {
    var isOpen = searchWrapper.classList.toggle('is-open');
    toggleBtn.classList.toggle('is-active', isOpen);
    if (isOpen) {
      fetchAllProducts();
      setTimeout(function() { input.focus(); }, 250);
    } else {
      input.value = '';
      clearAllFilters();
    }
  });

  /* --- TAG-FILTERS: Inject into Shopify filter bar --- */
  var filterConfig = null;
  var configEl = document.getElementById('jadel-filter-config');
  if (configEl) {
    try { filterConfig = JSON.parse(configEl.textContent); } catch(e) {}
  }

  var activeFilters = {};
  var facetsWrapper = document.getElementById('FacetsWrapperDesktop');

  if (filterConfig && filterConfig.length > 0 && facetsWrapper) {
    fetchAllProducts().then(function() {
      hideNonExistentTags();
    });

    filterConfig.forEach(function(group, gi) {
      if (!group.tags || group.tags.length === 0) return;
      activeFilters[group.naam] = [];

      var details = document.createElement('details');
      details.className = 'disclosure-has-popup facets__disclosure js-filter jadel-tag-detail';
      details.id = 'Details-jadel-tag-' + gi;

      var summary = document.createElement('summary');
      summary.className = 'facets__summary caption-large focus-offset';
      summary.setAttribute('role', 'button');
      summary.setAttribute('aria-expanded', 'false');
      summary.innerHTML = '<div><span>' + group.naam + '</span>' +
        '<svg class="icon icon-caret" viewBox="0 0 10 6"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"/></svg></div>';
      details.appendChild(summary);

      var dropdown = document.createElement('div');
      dropdown.className = 'facets__display jadel-tag-dropdown';

      var btnRow = document.createElement('div');
      btnRow.className = 'jadel-tag-dropdown__buttons';

      group.tags.forEach(function(tag) {
        var tagLower = tag.toLowerCase();
        var tagBtn = document.createElement('button');
        tagBtn.type = 'button';
        tagBtn.className = 'jadel-tag-btn';
        tagBtn.textContent = tag.charAt(0).toUpperCase() + tag.slice(1);
        tagBtn.dataset.tag = tagLower;
        tagBtn.dataset.group = group.naam;
        tagBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          tagBtn.classList.toggle('is-active');
          var groupTags = activeFilters[group.naam];
          var idx = groupTags.indexOf(tagLower);
          if (idx === -1) { groupTags.push(tagLower); } else { groupTags.splice(idx, 1); }
          applyFilters();
        });
        btnRow.appendChild(tagBtn);
      });

      dropdown.appendChild(btnRow);
      details.appendChild(dropdown);

      document.addEventListener('click', function(e) {
        if (!details.contains(e.target)) details.removeAttribute('open');
      });

      facetsWrapper.appendChild(details);
    });
  }

  function hideNonExistentTags() {
    if (!jadelAllProducts) return;
    var allTagsSet = {};
    jadelAllProducts.forEach(function(p) {
      getTagsArray(p).forEach(function(t) { allTagsSet[t] = true; });
    });
    document.querySelectorAll('.jadel-tag-btn').forEach(function(btn) {
      if (!allTagsSet[btn.dataset.tag]) btn.style.display = 'none';
    });
  }

  /* --- GECOMBINEERDE FILTER LOGICA (AJAX) --- */
  var isFiltering = false;

  var debounceTimer;
  input.addEventListener('input', function() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function() { applyFilters(); }, 200);
  });

  clearBtn.addEventListener('click', function() {
    input.value = '';
    applyFilters();
    input.focus();
  });

  function clearAllFilters() {
    input.value = '';
    Object.keys(activeFilters).forEach(function(k) { activeFilters[k] = []; });
    document.querySelectorAll('.jadel-tag-btn.is-active').forEach(function(b) { b.classList.remove('is-active'); });
    if (isFiltering) {
      productGrid.innerHTML = originalGridHTML;
      isFiltering = false;
      document.querySelectorAll('.pagination, .pagination-wrapper, nav[role="navigation"]').forEach(function(p) { p.style.display = ''; });
    }
    countLabel.style.display = 'none';
  }

  function applyFilters() {
    var query = input.value.trim().toLowerCase();
    var words = query ? query.split(/\s+/) : [];
    var hasSearch = words.length > 0;

    var hasTagFilters = false;
    var activeGroupFilters = [];
    Object.keys(activeFilters).forEach(function(groupName) {
      var tags = activeFilters[groupName];
      if (tags.length > 0) {
        hasTagFilters = true;
        activeGroupFilters.push(tags);
      }
    });

    if (!hasSearch && !hasTagFilters) {
      clearAllFilters();
      return;
    }

    if (!jadelAllProducts) {
      countLabel.style.display = 'inline';
      countLabel.textContent = 'Laden...';
      fetchAllProducts().then(function() {
        hideNonExistentTags();
        applyFilters();
      });
      return;
    }

    isFiltering = true;

    var filtered = jadelAllProducts.filter(function(product) {
      var ptags = getTagsArray(product);
      if (ptags.indexOf('actie') !== -1) return false;
      if (ptags.indexOf('sale') !== -1) return false;
      if (ptags.indexOf('maak-eigen-ketting') !== -1) {
        if (collectionHandle.indexOf('kralen') === -1) return false;
      }

      if (hasSearch) {
        var title = product.title.toLowerCase();
        var matched = words.every(function(w) { return title.indexOf(w) !== -1; });
        if (!matched) return false;
      }

      if (hasTagFilters) {
        var pass = activeGroupFilters.every(function(groupTags) {
          return groupTags.some(function(tag) {
            return ptags.indexOf(tag) !== -1;
          });
        });
        if (!pass) return false;
      }

      return true;
    });

    renderFilteredProducts(filtered);

    var totalVisible = jadelAllProducts.filter(function(p) {
      var ptags = getTagsArray(p);
      if (ptags.indexOf('actie') !== -1) return false;
      if (ptags.indexOf('sale') !== -1) return false;
      if (ptags.indexOf('maak-eigen-ketting') !== -1 && collectionHandle.indexOf('kralen') === -1) return false;
      return true;
    }).length;

    countLabel.style.display = 'inline';
    countLabel.textContent = filtered.length + ' / ' + totalVisible;

    document.querySelectorAll('.pagination, .pagination-wrapper, nav[role="navigation"]').forEach(function(p) { p.style.display = 'none'; });
  }

    function jadelCategorieNaam() {
    var h = '-' + collectionHandle + '-';
    var soorten = [
      ['telefoonkoorden', /telefoonkoord/],
      ['bag charms', /bag-charm|tashanger|keychain/],
      ['oorbellen', /oorbel|oorring|oorknop|ear-cuff/],
      ['armbanden', /armband|bangle|hand-chain/],
      ['kettingen', /ketting/],
      ['bedels', /bedel/],
      ['ringen', /-ring/]
    ];
    var beste = null, plek = 9999;
    soorten.forEach(function(s) {
      var m = h.match(s[1]);
      if (m && m.index < plek) { plek = m.index; beste = s[0]; }
    });
    return beste || 'toppers';
  }
    var jadelHardlopers = null;
  var jadelHardlopersLaden = null;
  function jadelToonHardlopers() {
    var sectionId = productGrid.getAttribute('data-id');
    function plaats(items) {
      if (!productGrid.querySelector('.jadel-no-results')) return;
      if (productGrid.querySelector('.jadel-hardloper')) return;
      items.forEach(function(li) {
        var kopie = li.cloneNode(true);
        kopie.classList.add('jadel-hardloper');
        productGrid.appendChild(kopie);
      });
    }
    if (jadelHardlopers) { plaats(jadelHardlopers); return; }
    if (!sectionId) return;
    if (!jadelHardlopersLaden) {
      jadelHardlopersLaden = fetch('/collections/' + collectionHandle + '?sort_by=best-selling&section_id=' + sectionId)
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          jadelHardlopers = Array.prototype.slice.call(doc.querySelectorAll('#product-grid > li.grid__item'))
            .filter(function(li) { return !li.querySelector('.badge.color-inverse'); })
            .slice(0, 3)
            .map(function(li) { li.classList.remove('scroll-trigger', 'animate--slide-in'); return li; });
          return jadelHardlopers;
        })
        .catch(function() { jadelHardlopersLaden = null; return []; });
    }
    jadelHardlopersLaden.then(plaats);
  }
  function renderFilteredProducts(products) {
    productGrid.innerHTML = '';
    if (products.length === 0) {
       productGrid.innerHTML = '<li class="grid__item jadel-no-results" style="grid-column:1/-1;text-align:center;padding:30px 20px 10px;"><p style="font-size:16px;color:#666;margin:0 0 6px;">Geen producten gevonden</p><p style="font-size:15px;font-weight:600;margin:0;">Misschien vind je deze ' + jadelCategorieNaam() + ' leuk:</p></li>';
      jadelToonHardlopers();
      return;
    }
    products.forEach(function(product) {
      var li = document.createElement('li');
      li.className = 'grid__item jadel-ajax-product';

      var img = (product.images && product.images.length > 0) ? product.images[0].src : '';
      var price = product.variants && product.variants[0] ? product.variants[0].price : '0.00';
      var comparePrice = product.variants && product.variants[0] ? product.variants[0].compare_at_price : null;
      var url = '/products/' + product.handle;

      var priceNum = parseFloat(price);
      var priceFormatted = '€' + priceNum.toFixed(2).replace('.', ',');
      var discountHTML = '';

      if (comparePrice && parseFloat(comparePrice) > priceNum) {
        var compareNum = parseFloat(comparePrice);
        var pct = Math.round((1 - priceNum / compareNum) * 100);
        discountHTML = '<span class="jadel-ajax-product__compare">€' + compareNum.toFixed(2).replace('.', ',') + '</span>' +
          '<span class="jadel-ajax-product__discount">-' + pct + '%</span>';
      }

      li.innerHTML = '<a href="' + url + '" class="jadel-ajax-product__link">' +
        '<div class="jadel-ajax-product__img-wrap">' +
          (img ? '<img src="' + img.replace(/\.([a-z]+)$/i, '_400x.$1') + '" alt="' + product.title.replace(/"/g, '&quot;') + '" loading="lazy">' : '') +
          (discountHTML ? '<span class="jadel-ajax-product__badge">-' + pct + '%</span>' : '') +
        '</div>' +
        '<div class="jadel-ajax-product__info">' +
          '<h3 class="jadel-ajax-product__title">' + product.title + '</h3>' +
          '<div class="jadel-ajax-product__price">' + discountHTML + ' ' + priceFormatted + '</div>' +
        '</div></a>';

      productGrid.appendChild(li);
    });
  }

});

/* === Gratis-verzendingsbalk (Hextom Free Shipping Bar app) === */
/* Maakt de balk kleiner en voegt een sluit-/inklapknop toe, ook als de app-eigen */
/* "close" optie uit staat. Onthoudt de keuze 24 uur via localStorage. */
(function () {
  var HIDE_KEY = 'jadel_fsb_hidden_until';

  function isHidden() {
    try {
      var t = localStorage.getItem(HIDE_KEY);
      return !!t && Date.now() < parseInt(t, 10);
    } catch (e) {
      return false;
    }
  }

  function rememberHidden() {
    try {
      localStorage.setItem(HIDE_KEY, String(Date.now() + 24 * 60 * 60 * 1000));
    } catch (e) {}
  }

  function findBarRoot(msgEl) {
    var el = msgEl;
    while (el.parentElement && el.parentElement !== document.body && el.parentElement !== document.documentElement) {
      el = el.parentElement;
    }
    return el;
  }

  function enhance(msgEl) {
    var bar = findBarRoot(msgEl);
    if (!bar || bar.dataset.jadelFsbDone) return;
    bar.dataset.jadelFsbDone = '1';
    bar.classList.add('jadel-fsb-bar');

    if (isHidden()) {
      bar.classList.add('jadel-fsb-collapsed');
      return;
    }

    var closeBtn = document.getElementById('fsb_close');
    if (!closeBtn || getComputedStyle(closeBtn).display === 'none') {
      closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.setAttribute('aria-label', 'Balk sluiten');
      closeBtn.textContent = '×';
      if (getComputedStyle(bar).position === 'static') {
        bar.style.position = 'relative';
      }
      bar.appendChild(closeBtn);
    }
    closeBtn.classList.add('jadel-fsb-close');
    closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      bar.classList.add('jadel-fsb-collapsed');
      rememberHidden();
    });
  }

  function scan() {
    var msg = document.getElementById('fsb_message');
    if (msg) enhance(msg);
  }

  scan();
  var jadelFsbObserver = new MutationObserver(scan);
  jadelFsbObserver.observe(document.documentElement, { childList: true, subtree: true });
})();

/* === Live chat knop (Shopify Inbox) === */
/* Alleen het icoon tonen (geen "Chat"-tekst) + een klein sluitkruisje waarmee de */
/* bezoeker de chatbubbel kan wegklikken. Die keuze wordt 24 uur onthouden via */
/* localStorage (zelfde patroon als de free-shipping-balk hierboven). Schuift */
/* daarnaast omhoog zodra de sticky "voeg toe aan winkelwagen"-balk op mobiel */
/* zichtbaar is, zodat ze elkaar niet overlappen. */
(function () {
  var HIDE_KEY = 'jadel_chat_hidden_until';

  function isHidden() {
    try {
      var t = localStorage.getItem(HIDE_KEY);
      return !!t && Date.now() < parseInt(t, 10);
    } catch (e) {
      return false;
    }
  }

  function rememberHidden() {
    try {
      localStorage.setItem(HIDE_KEY, String(Date.now() + 24 * 60 * 60 * 1000));
    } catch (e) {}
  }

  function setup(chatEl) {
    if (chatEl.dataset.jadelChatDone) return;
    var root = chatEl.shadowRoot;
    if (!root) return;
    var btn = root.querySelector('[part="activator"]');
    var nudge = root.querySelector('.activator-nudge');
    if (!btn || !nudge) return;
    chatEl.dataset.jadelChatDone = '1';

    if (isHidden()) {
      chatEl.style.setProperty('display', 'none', 'important');
      return;
    }

    /* Alleen het icoon, geen tekstlabel */
    var label = root.querySelector('.activator__label');
    var icon = root.querySelector('.activator__icon');
    if (label) label.style.setProperty('display', 'none', 'important');
    if (icon) icon.style.removeProperty('display');
    btn.style.setProperty('padding', '0', 'important');
    btn.style.setProperty('width', '48px', 'important');
    btn.style.setProperty('min-width', '0', 'important');
    btn.style.setProperty('justify-content', 'center', 'important');
    btn.style.setProperty('gap', '0', 'important');

    /* Sluitkruisje: laat de bezoeker de chatbubbel wegklikken */
    if (getComputedStyle(nudge).position === 'static') {
      nudge.style.position = 'relative';
    }
    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.setAttribute('aria-label', 'Chat verbergen');
    closeBtn.textContent = '×';
    closeBtn.style.cssText = 'position:absolute;top:-6px;right:-6px;width:18px;height:18px;line-height:16px;border-radius:50%;border:none;background:#fff;color:#333;font-size:14px;font-weight:600;box-shadow:0 1px 4px rgba(0,0,0,.25);cursor:pointer;padding:0;z-index:2;';
    nudge.appendChild(closeBtn);
    closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      chatEl.style.setProperty('display', 'none', 'important');
      rememberHidden();
    });

    /* De knop blijft op zijn vaste plek staan, ook als de sticky
       "voeg toe aan winkelwagen"-balk verschijnt (niet meer laten meebewegen). */
  }

  function scanChat() {
    var chatEl = document.querySelector('shopify-chat');
    if (chatEl) setup(chatEl);
  }

  scanChat();
  var jadelChatObserver = new MutationObserver(scanChat);
  jadelChatObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
